import { put } from "@vercel/blob/client";
import { compressImageIfNeeded } from "utils/mmsImage";

// Both campaign and conversation attachments use the same browser compressor.
// Final size/type and ownership are checked by the server before the draft is ready.
export async function uploadConversationImage(file, { apiBase, token, signal }) {
  if (file.size > 15 * 1024 * 1024) throw new Error("Maximum supported image upload is 15 MB");
  const { dataUrl, fileName } = await compressImageIfNeeded(file);
  const blob = await (await fetch(dataUrl)).blob();
  if (!["image/jpeg", "image/png", "image/gif"].includes(blob.type) || blob.size > 4000000) throw new Error("Select a supported image under 4 MB after compression");
  const request = async (path, body) => {
    const response = await fetch(`${apiBase}/media/conversations/${path}`, { method: "POST", signal, headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" }, body: JSON.stringify(body) });
    const result = await response.json(); if (!response.ok || !result.success) throw new Error(result.message || "Attachment upload failed"); return result.media;
  };
  const draft = await request("drafts", { fileName, mimeType: blob.type, sizeBytes: blob.size });
  if (draft.uploadMode === "direct") {
    await put(draft.pathname, blob, { token: draft.clientToken, access: "private", contentType: blob.type, abortSignal: signal });
    return request(`${draft.id}/complete`, {});
  }
  return request(`${draft.id}/complete`, { fileData: dataUrl.slice(dataUrl.indexOf(",") + 1) });
}

// Caller owns/revokes object URLs made from this Blob when a preview unmounts.
export async function downloadConversationImage(media, { apiBase, token, signal }) {
  if (!Number.isSafeInteger(media.sizeBytes) || media.sizeBytes <= 0 || media.sizeBytes > 10 * 1024 * 1024) throw new Error("Attachment unavailable");
  const parts = [];
  for (let start = 0; start < media.sizeBytes; start += 1048576) {
    const end = Math.min(start + 1048575, media.sizeBytes - 1);
    const response = await fetch(`${apiBase}/media/conversations/${media.id}/content`, { signal, headers: { Authorization: `Bearer ${token}`, Range: `bytes=${start}-${end}` } });
    if (response.status !== 206 || response.headers.get("Content-Range") !== `bytes ${start}-${end}/${media.sizeBytes}`) throw new Error("Attachment download failed");
    const data = await response.arrayBuffer(); if (data.byteLength !== end - start + 1) throw new Error("Incomplete attachment download"); parts.push(data);
  }
  return new Blob(parts, { type: media.mimeType });
}
